(function ($) {
    class W4D_Instashop {
        constructor() {
            this.isPopupOpen = false;
            this.initSelectors();
            this.bindEvents();
        }

        initSelectors() {
            this.body = $('body');
            this.instashop2Marker = '.instashop-2__marker';
            this.instashop2Popup = '.instashop-2__popup';

            this.instashopMobileOverlay = $('.instashop-2__mobile-overlay');
            this.instashopOpenMobileOverlay = $('.js-instashop-open-mobile-overlay');
            this.instashopCloseMobileOverlay = $('.js-instashop-close-mobile-overlay');
        }

        bindEvents() {
            // Handle marker clicks with event delegation
            $(document).on('click', this.instashop2Marker, (e) => {
                e.stopPropagation();
                this.handleMarkerClick($(e.currentTarget));
            });

            // Handle outside clicks only when popup is active
            $(document).on('click', (e) => {
                if (!this.isPopupOpen) return;

                const $target = $(e.target);
                const isClickOnPopup = $target.closest(this.instashop2Popup).length > 0;
                const isClickOnMarker = $target.closest(this.instashop2Marker).length > 0;

                if (!isClickOnPopup && !isClickOnMarker) {
                    this.closePopup();
                }
            });

            this.instashopOpenMobileOverlay.on('click', () => {
                this.openMobileOverlay();
            });

            this.instashopCloseMobileOverlay.on('click', () => {
                this.closeMobileOverlay();
            });

            this.instashopMobileOverlay.on('click', (e) => {
                if (e.target === e.currentTarget) {
                    this.closeMobileOverlay();
                }
            });
        }

        openMobileOverlay() {
            this.body.addClass('instashop-mobile-overlay-active');
            this.instashopMobileOverlay.addClass('instashop-2__mobile-overlay--active');
        }

        closeMobileOverlay() {
            this.body.removeClass('instashop-mobile-overlay-active');
            this.instashopMobileOverlay.removeClass('instashop-2__mobile-overlay--active');
        }

        handleMarkerClick($marker) {
            const popupTarget = $marker.data('popup-target');
            const $popup = $(popupTarget);

            if ($popup.hasClass('instashop-2__popup--active')) {
                this.closePopup();
            } else {
                this.closePopup(); // Close any other popup first
                this.positionAndShowPopup($marker, $popup);
            }
        }

        positionAndShowPopup($marker, $popup) {
            const markerPos = $marker.position();
            const markerW = $marker.outerWidth();
            const markerH = $marker.outerHeight();

            const popupW = $popup.outerWidth();
            const popupH = $popup.outerHeight();

            const $container = $marker.closest('.instashop-2__content');
            const contW = $container.innerWidth();
            const contH = $container.innerHeight();

            let topValue = markerPos.top + (markerH / 2) - (popupH / 2);
            if (topValue < 10) topValue = 10;
            if (topValue + popupH > contH - 10) topValue = contH - popupH - 10;

            const spaceRight = contW - (markerPos.left + markerW);
            const leftValue = spaceRight < popupW + 10
                ? markerPos.left - popupW - 10
                : markerPos.left + markerW + 10;

            $marker.addClass('instashop-2__marker--active');
            $popup.addClass('instashop-2__popup--active');
            $popup.css({
                '--top-offset': topValue + 'px',
                '--left-offset': leftValue + 'px'
            });

            this.isPopupOpen = true;
        }

        closePopup() {
            $(this.instashop2Marker).removeClass('instashop-2__marker--active');
            $(this.instashop2Popup).removeClass('instashop-2__popup--active');
            this.isPopupOpen = false;
        }
    }

    $(document).ready(function () {
        window.W4D_Instashop = new W4D_Instashop();
    });
})(jQuery);